module.exports = __webpack_public_path__ + "static/media/Nguyen_Viet_Huy.4e114b92.jpg";